import React from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import VtexComponent from '../components/canvas/VtexComponent';
import VtexVisualizationComponent from '../components/canvas/VtexVisualizationComponent';
import { visualizationMode } from '../redux/visualizationModeSlice';

const SlotComponent = ({ props }: any) => {
	const VMMode = useSelector(visualizationMode);
	const [searchParams] = useSearchParams();
	const isCanvas = searchParams.get('isCanvas');

	if (VMMode || isCanvas) {
		return (
			<VtexVisualizationComponent
				{...{
					key: props.componentId,
					componentId: props.componentId,
					componentGroup: props.componentGroup,
					comp: props,
				}}
			/>
		);
	}
	return (
		<VtexComponent
			{...{
				key: props.componentId,
				componentId: props.componentId,
				componentGroup: props.componentGroup,
				comp: props,
			}}
		/>
	);
};

export default SlotComponent;
